<mat-icon class="warning-icon">warning</mat-icon>
<span class="margin-left-md">{{ error }}</span>